import React, {Component} from 'react';
import {close_popup, show_popup} from "../functions";
import {gTagClickEventValue} from "./frontend_script";

class BookingChoisePage extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onReset = this.onReset.bind(this);
	}

	onChange(hire) {
		try {
			gTagClickEventValue((hire === 'local' ? 'click_to_switch' : 'click_to_switch_interstate'), {'event_category': 'booking', 'event_label': 'booking-switch'});
		}
		catch (e) {
		}
		gTagClickEventValue('click', {'event_category': 'booking', 'event_label': 'booking-switch'});

		if (this.props.hire !== hire && this.props.hire !== '') {
			let content =
				<div className="row error-booking-popup">
					<div className="col-12 text-center">
						<div className="row m-3">
							<div className="col-12 text-center gray">
								<h4>Confirm</h4>
								<br/>
								Are You Sure?
								<br/>
								All changes will be lost.
							</div>
						</div>
						<div className="row mb-3">
							<div className="col-12 text-center">
								<button type="button"
										className="go-btn go-back mx-auto"
										onClick={close_popup}/>
								<button type="button"
										className="go-btn go-next mx-auto"
										onClick={() => this.onReset(hire)}/>
							</div>
						</div>
					</div>
				</div>;
			show_popup(content, {auto_close: false});
		}
		else if(this.props.hire === '') {
			this.onReset(hire);
		}
	}

	onReset(hire) {
		let div = '';
		if (hire === 'local')
			div = 'id_search_form_local_div';
		else if (hire === 'interstate')
			div = 'id_search_form_interstate_div';

		this.props.handleSetSomeBlock('scroll_to_element', div);
		this.props.handleSetSomeBlock('category_group_filter', 0);

		this.props.handleSetHire(hire);
		close_popup();
	}

	render() {
		return (
			<div style={{padding: "20px 30px"}}>
				<div className="row">
					<div className="offset-2 col-8 my-4 text-center">
						<h1>Where would you like to go?</h1>
					</div>
				</div>
				<div className="row">
					<div className="offset-2 col-8 text-center form-inputs">
						<p>A ‘Local’ booking is for use within the metro area or a 50KM radius of your chosen hire location. If you intend to drive from city to city or between states please select interstate hire.</p>
					</div>
				</div>
				<div className="row justify-content-center my-4">
					<div className="col-auto">
						<button type="button" style={{marginBottom: "10px"}} className={'btn col '+(this.props.hire == 'local' ? 'btn-danger' : 'btn-outline-danger')} onClick={() => this.onChange('local')}>
							LOCAL HIRE
						</button>
					</div>
					<div className="col-auto">
						<button type="button" style={{marginBottom: "10px"}} className={'btn col '+(this.props.hire == 'interstate' ? 'btn-danger' : 'btn-outline-danger')} onClick={() => this.onChange('interstate')}>
							INTERSTATE HIRE
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default BookingChoisePage;